import { handleFirstResponse } from '../utils/util_api_response';
import { checkErrorExist, convertError } from './converters';

import GLOBAL from '../configs/config_global';

// region Function - Fetch with Progress
export function progressFetch(url, opts = {}, onProgress) {
    return new Promise((res, rej) => {
        let xhr = new XMLHttpRequest();
        xhr.open(opts.method || 'get', url);
        for (let k in opts.headers || {}) {
            xhr.setRequestHeader(k, opts.headers[k]);
        }

        xhr.onload = (e) => res(e.target);
        xhr.onerror = rej;
        if (xhr.upload && onProgress) {
            xhr.upload.onprogress = onProgress; // event.loaded / event.total * 100 ; //event.lengthComputable
        }

        xhr.send(opts.body);
    });
}
// endregion

// region API Wrapper
export function apiWrapper(link, method = 'POST', functionName = '', body = null, completeFunc = () => {}, extraHeaders) {
    return new Promise((resolve, reject) => {
        const hasPagination = link.toLowerCase().includes('page') || link.toLowerCase().includes('per_page');

        // Check if this is Form Data
        const isFormData = body instanceof FormData;

        // Configure Abort Controller
        const controller = new AbortController();
        const cancelConfig = setTimeout(() => controller.abort(), 10000);

        // Configure Headers
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN,
            ...extraHeaders
        };
        (method !== 'POST' && method !== 'PATCH') && (headers['Content-Type'] = (isFormData ? 'multipart/form-data' : 'application/json'));

        // Start fetching
        fetch((link.startsWith('http') ? '' : GLOBAL.FATHER_LINK) + link, {
            method: method,
            signal: controller.signal,
            headers,
            body
        })
            .then((response) => {
                clearTimeout(cancelConfig);
                return handleFirstResponse(response);
            })
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log(`[SUCCESS] ${functionName.toUpperCase()}`, response);
                    completeFunc(response);
                    resolve(
                        hasPagination ?
                            {
                                data: response.data,
                                currentPage: (response['meta'] || response)['current_page'],
                                lastPage: (response['meta'] || response)['last_page'],
                                totalResult: (response['meta'] || response)['total'],
                                meta: response['meta'] || {}
                            }
                            :
                            response
                    );
                }
                else {
                    console.log(`[FAILED] ${functionName.toUpperCase()}`, response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log(`[FAILED] ${functionName.toUpperCase()}`, error);
                if (error.message === 'Aborted') {
                    reject('Slow network connection impacting app performance. Please try again later.');
                }
                else reject(error.message);
            });
    });
}
// endregion
